// extracted by mini-css-extract-plugin
export default {"editor-page":"EditorPage-module__editor-page___cZtDG","editor-page__group-wrapper":"EditorPage-module__editor-page__group-wrapper___xCVCN"};